import { Store } from "../../../../@core/store/store";

export class RecentlyAccessedAppsLoadingState extends Store.AbstractLoadingState<any> { }
export class RecentlyAccessedAppsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RecentlyAccessedAppsLoadedState extends Store.AbstractIdealState<any> { }

export class RemindersLoadingState extends Store.AbstractLoadingState<any> { }
export class RemindersLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RemindersLoadedState extends Store.AbstractIdealState<any> { }

export class DynamicStackLoadingState extends Store.AbstractLoadingState<any> { }
export class DynamicStackLoadingErrorState extends Store.AbstractErrorState<any> { }
export class DynamicStackLoadedState extends Store.AbstractIdealState<any> { }

export class AnnouncementsLoadingState extends Store.AbstractLoadingState<any> { }
export class AnnouncementsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class AnnouncementsLoadedState extends Store.AbstractIdealState<any> { }

export class CarouselDataLoadingState extends Store.AbstractLoadingState<any> { }
export class CarouselDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class CarouselDataLoadedState extends Store.AbstractIdealState<any> { }

export class profileDataLoadingState extends Store.AbstractLoadingState<any> { }
export class profileDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class profileDataLoadedState extends Store.AbstractIdealState<any> { }

export class getCalendarEventsLoadingState extends Store.AbstractLoadingState<any> {}
export class getCalendarEventsLoadingErrorState extends Store.AbstractErrorState<any> {}
export class getCalendarEventsLoadedState extends Store.AbstractIdealState<any> {}

export class calendarConsentLoadingState extends Store.AbstractLoadingState<any> {}
export class calendarConsentLoadingErrorState extends Store.AbstractErrorState<any> {}
export class calendarConsentLoadedState extends Store.AbstractIdealState<any> {}